import BaseComponent from '../../../js/base-component';
import { Loader } from '@googlemaps/js-api-loader';
// import { MarkerClusterer } from '@googlemaps/markerclusterer'; -- script is included in store-map.twig

class StoreMap extends BaseComponent {
    constructor(options) {
        super(options);

        const apiKey = "AIzaSyBQ_aCybg5OOLgDeSGbDDptzH2hQ_vTfgA"; // Seeger DEV -- AIzaSyDIpv2RliUBlrAy3lCXmn0aKsR70RPKAac

        this.geocoder;
        this.map;
        this.mapContainer = this.element.querySelector('.u-store-map__map');
        this.mapForm = this.element.querySelector('#storeMapForm');
        this.mapForm.addEventListener("submit", (e) => { this.codeAddress(e) }, false);

        window.addEventListener('CookiebotOnAccept', (e) => {
            if (Cookiebot.consent.preferences) {
                this.consent = Cookiebot.consent.preferences;

                // load Maps, apikey & version
                this.loader = new Loader({
                    apiKey: apiKey,
                    version: "weekly",
                });

                if ( this.mapContainer && this.consent ) {
                    this.loadMap();
                }
            }
        }, false);
    }

    loadMarkerClusterer(map) {
        const markers = [];
        const locations = document.querySelectorAll('.u-address__item') || [];

        const infoWindow = new google.maps.InfoWindow({
            content: "",
            disableAutoPan: true,
        });

        if (locations.length) {
            locations.forEach((pin, i) => {
                let marker = new google.maps.Marker({
                    position: { lat: Number(pin.dataset.latitude), lng: Number(pin.dataset.longitude) },
                    title: pin.dataset.id,
                });

                marker.addListener("click", () => {
                    // todo: set infowindow content
                    console.log(pin);
                    infoWindow.setContent(`<div class="u-store-map__infoWindow">${pin.innerHTML}</div>`);
                    infoWindow.open(map, marker);
                });

                markers.push(marker);
            });

            const markerCluster = new markerClusterer.MarkerClusterer({ map, markers });

            this.mapContainer.classList.add('hidden');
        }
    }

    loadMap() {
        this.loader.loadCallback(e => {
            if (e) {
                console.log(e);
            } else {
                const lat = Number(this.mapContainer.dataset.latitude);
                const lng = Number(this.mapContainer.dataset.longitude);

                this.mapContainer.classList.remove('not-loaded');

                this.map = new google.maps.Map(this.mapContainer, {
                    zoom: 9,
                    center: { lat: lat, lng: lng },
                    mapTypeControl: false,
                    streetViewControl: false,
                });

                this.geocoder = new google.maps.Geocoder();
                this.loadMarkerClusterer( this.map );
            }
        });
    }

    codeAddress(e) {
        e.preventDefault();

        let address = document.getElementById('address').value;

        this.mapContainer.classList.remove('hidden');
        this.mapContainer.classList.remove('not-shown');

        if (address.length) {
            if ( typeof this.geocoder !== 'undefined' ) {
                this.geocoder.geocode( {
                    'address': address,
                    componentRestrictions: {
                        country: 'DE',
                    }
                }, (results, status) => {
                    if (status == 'OK') {
                        this.map.setCenter(results[0].geometry.location);
                        this.map.fitBounds(results[0].geometry.bounds);
                        // map.setZoom(9);
                        // console.log(results);
                    } else {
                        alert('Ort wurde nicht gefunden oder liegt ausserhalb Deutschlands.');
                    }
                });
            }
        }
    }
}

export default {
    name: 'StoreMap',
    definition: StoreMap
};
